import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  EMPTY_VENDOR_BRANDING,
  VendorBranding,
  VendorOfferShell,
} from './VendorOfferChrome';
import NotFound from './NotFound';
import { VENDOR_OFFER_SUCCESS_PAGES } from './vendorOfferSuccessConfig';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const IOS_APP_STORE_URL =
  process.env.REACT_APP_APP_STORE_URL ||
  'https://apps.apple.com/us/app/heal-music-breath/id6746941693';

const VendorOfferSuccess: React.FC = () => {
  const { partner } = useParams<{ partner: string }>();
  const offer = partner ? VENDOR_OFFER_SUCCESS_PAGES[partner] : undefined;
  const [branding, setBranding] = useState<VendorBranding>({
    ...EMPTY_VENDOR_BRANDING,
    vendorName: offer?.vendorName ?? null,
  });

  useEffect(() => {
    if (!offer) return;
    let cancelled = false;

    setBranding({
      ...EMPTY_VENDOR_BRANDING,
      vendorName: offer.vendorName,
    });

    const loadBranding = async () => {
      try {
        const response = await fetch(`${API_URL}/vendor-offers/tokens/${offer.token}`);
        if (!response.ok) return;
        const data = await response.json();
        if (cancelled) return;
        setBranding({
          vendorName: data?.vendor_name ?? offer.vendorName,
          logoUrl: data?.logo_url ?? null,
          headline: data?.headline ?? null,
          bodyText: data?.body_text ?? null,
          successText: data?.success_text ?? null,
          questionnaireSlug: data?.questionnaire_slug ?? null,
        });
      } catch {
        // The download message still stands if branding cannot be loaded.
      }
    };

    loadBranding();
    return () => {
      cancelled = true;
    };
  }, [offer]);

  if (!offer) {
    return <NotFound />;
  }

  return (
    <VendorOfferShell branding={branding}>
      <div className="vendor-offer-main">
        <h1 className="vendor-offer-title">You're all set</h1>
        <p className="vendor-offer-subtitle">{offer.body}</p>
        <a
          className="vendor-offer-submit vendor-offer-submit-link"
          href={IOS_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download on the App Store
        </a>
      </div>
    </VendorOfferShell>
  );
};

export default VendorOfferSuccess;
